import { css } from 'styled-components';

const EarnExtraPointsTileNewStyle = css`
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.colorPalette.blue[100]};
  border-radius: 8px;
  width: 100%;
  padding: ${(props) => `23px ${props.theme.spacing.ELEM_SPACING.MED} 27px`};
  ${(props) => (props.isAccountDrawer ? 'width: auto;' : '')};
  ${(props) => props.isAccountDrawer && 'border-radius: 0'};
  .start-earning-points-text {
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    font-size: ${(props) => props.theme.typography.fontSizes.fs20};
    text-transform: uppercase;
    color: ${(props) => props.theme.colorPalette.gray[900]};
  }
  .earn-tile-heading {
    align-items: center;
    display: flex;
  }
  .start-earn-points-heading {
    align-items: center;
    display: flex;
    justify-content: center;
    text-transform: uppercase;
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-weight: ${(props) => props.theme.typography.fontWeights.bold};
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    color: ${(props) => props.theme.colorPalette.gray[900]};
  }
  .earn-extra-tile-wrapper {
    width: auto;
  }
  &.earn-extra-tile-wrapper-drawer {
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      padding-right: 40px;
    }
  }
  .tileWrapper {
    @media ${(props) => props.theme.mediaQuery.large} {
      flex-basis: 22.7%;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      flex-basis: 47.7%;
    }
  }

  .tileWrapperMobile {
    @media ${(props) => props.theme.mediaQuery.large} {
      flex-basis: 22.7%;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      flex-basis: 47.7%;
    }
  }

  .earn-tile-main {
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    justify-content: space-around;
    ${(props) => props.isAccountDrawer && 'justify-content: center;'};
  }

  .earn-extra-view-all {
    text-decoration: underline;
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    line-height: 22px;
  }

  .earn-extra-view-all-wrapper {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    display: flex;
    width: 100%;
    justify-content: center;
    .earn-extra-view-all-button {
      border-radius: 6px;
      width: 65%;
      text-align: center;
      padding: 16px 0;
      font-family: ${(props) => props.theme.typography.fonts.secondary};
      font-weight: ${(props) => props.theme.typography.fontWeights.regular};
      font-size: ${(props) => props.theme.typography.fontSizes.fs16};
      color: ${(props) => props.theme.colorPalette.gray[900]};
      text-transform: uppercase;
      border: 1px solid ${(props) => props.theme.colorPalette.gray[600]};
    }
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    .earn-extra-view-all-mobile {
      display: none;
    }
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    border-radius: 0;
    .earn-tile-main {
      display: flex;
      flex-direction: row;
    }
    .earn-extra-point-icon {
      display: none;
    }
    .earn-extra-view-all {
      display: none;
    }
    .earn-extra-view-all-mobile {
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
      display: flex;
      width: 100%;
      justify-content: center;
    }
    .earn-extra-view-all-button {
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        width: 58%;
      }
      border-radius: 6px;
      width: 85%;
      text-align: center;
      padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED} 0;
    }
  }
`;
export default EarnExtraPointsTileNewStyle;
